"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 1H1c-.6 0-1 .5-1 1v12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.5-.4-1-1-1zm-1 12H2v-2h12v2zm0-3H2V8h12v2zm0-3H2V5h12v2z"];
//# sourceMappingURL=th-list.js.map